@if (kategorie(); as kat) {
  <section #bereich class="kpu" data-testid="ki-pipeline-ursache" tabindex="-1" [attr.aria-labelledby]="labelId">
    <div class="kpu__stufe1" [class.kpu__stufe1--testfehler]="kat === 'TESTFEHLER'">
      <div class="kpu__kopf">
        <span class="kpu__label" [id]="labelId">{{ 'ki.pipeline.ursache.label' | translate }}</span>
        <app-pipe-kategorie-pill [kategorie]="kat" [aussagekraeftig]="aussagekraeftig()" />
        @if (!aussagekraeftig()) {
          <span class="kpu__badge" data-testid="ki-pipeline-nicht-aussagekraeftig">
            {{ 'ki.pipeline.ursache.nichtAussagekraeftig' | translate }}
          </span>
        }
        <span class="kpu__spacer"></span>
        @if (verknuepfterBug(); as bug) {
          <a
            class="kpu__link"
            data-testid="ursache-bug-link"
            target="_blank"
            rel="noopener noreferrer"
            [attr.href]="bug.url"
            [attr.aria-label]="'ki.pipeline.erklaeren.bugOeffnenAria' | translate: { key: bug.key }"
          >
            {{ bug.key }}
            <span aria-hidden="true">↗</span>
          </a>
        }
        @if (ciUrl(); as url) {
          <a class="kpu__link" data-testid="ki-pipeline-ci-link" [href]="url" target="_blank" rel="noopener noreferrer">
            {{ 'ki.pipeline.ursache.ciOeffnen' | translate }}
            <span aria-hidden="true">↗</span>
            @if (befund().fehlerZeile; as zeile) {
              {{ 'ki.pipeline.ursache.zeile' | translate: { zeile } }}
            }
          </a>
        }
      </div>
      <p class="kpu__text">{{ 'pipeKategorie.' + kat + '.text' | translate }}</p>
      <div class="kpu__felder">
        <div class="kpu__feld">
          <div class="kpu__feld-label">{{ 'ki.pipeline.ursache.jobSchritt' | translate }}</div>
          <div class="kpu__feld-wert">
            @if (jobSchritt(); as text) {
              <code>{{ text }}</code>
            } @else {
              —
            }
          </div>
        </div>
        <div class="kpu__feld">
          <div class="kpu__feld-label">{{ 'ki.pipeline.ursache.zustaendig' | translate }}</div>
          <div class="kpu__feld-wert">{{ 'pipeKategorie.' + kat + '.wer' | translate }}</div>
        </div>
        <div class="kpu__feld">
          <div class="kpu__feld-label">{{ 'ki.pipeline.ursache.zaehltAls' | translate }}</div>
          <div class="kpu__feld-wert">{{ zaehltAlsKey() | translate }}</div>
        </div>
      </div>
    </div>

    @if (kiMoeglich()) {
      <div class="kpu__stufe2" data-testid="ki-pipeline-stufe2">
        @switch (run.zustand().art) {
          @case ('bereit') {
            @if (!anzeige()) {
              <div class="kpu__start" data-testid="ki-pipeline-start">
                <app-ki-button
                  funktion="PIPELINE_ANALYSE"
                  [label]="'ki.pipeline.erklaeren.button' | translate"
                  (ausloesen)="erklaeren()"
                />
                <span class="kpu__untertext" data-testid="ki-pipeline-untertext">{{ untertextKey() | translate }}</span>
              </div>
            }
          }
          @case ('laeuft') {
            <app-ki-laeuft [aktion]="'ki.pipeline.erklaeren.laeuft' | translate" />
          }
        }

        @if (fehlerKey(); as textKey) {
          <app-ki-fehler
            [text]="textKey | translate"
            [erneutAnbieten]="erneutSinnvoll()"
            (erneut)="erneutVersuchen()"
          />
        }

        @if (anzeige(); as a) {
          <div class="kpu__ergebnis-kopf" data-testid="ki-pipeline-ergebnis-kopf">
            <app-ki-badge [label]="'ki.pipeline.erklaeren.badge' | translate" />
            <span class="kpu__analysiert" data-testid="ki-pipeline-analysiert">
              {{
                'ki.pipeline.erklaeren.analysiertAm'
                  | translate: { datum: a.ergebnis.analysiertAm | date: 'dd.MM.yyyy · HH:mm' }
              }}
            </span>
            @if (a.sicherheit; as sicherheit) {
              <span [class]="'kpu__sicherheit kpu__sicherheit--' + sicherheit" data-testid="ki-pipeline-sicherheit">
                {{
                  'ki.pipeline.erklaeren.sicherheit'
                    | translate: { wert: ('ki.pipeline.erklaeren.sicherheitWert.' + sicherheit | translate) }
                }}
              </span>
            }
            <span class="kpu__spacer"></span>
            <button
              type="button"
              class="kpu__erneut-analysieren"
              data-testid="ki-pipeline-erneut-analysieren"
              (click)="erklaeren()"
            >
              {{ 'ki.pipeline.erklaeren.erneutAnalysieren' | translate }}
            </button>
          </div>

          <p class="kpu__zusammenfassung" data-testid="ki-pipeline-zusammenfassung">{{ a.ergebnis.zusammenfassung }}</p>

          <div class="kpu__kacheln">
            <div class="kpu__kachel">
              <div class="kpu__kachel-label">{{ 'ki.pipeline.erklaeren.ursache' | translate }}</div>
              <div class="kpu__ki-ursache" data-testid="ki-pipeline-ki-ursache">{{ a.ergebnis.ursache }}</div>
            </div>
            @if (aktionAnbieten() || erneutStartenAnbieten() || verknuepfterBug()) {
              <div class="kpu__kachel">
                <div class="kpu__kachel-label">{{ 'ki.pipeline.erklaeren.aktion' | translate }}</div>
                <div class="kpu__aktionen">
                  @if (verknuepfterBug(); as bug) {
                    <a
                      class="kpu__bug-link"
                      data-testid="ursache-bug-link-aktion"
                      target="_blank"
                      rel="noopener noreferrer"
                      [attr.href]="bug.url"
                      [attr.aria-label]="'ki.pipeline.erklaeren.bugOeffnenAria' | translate: { key: bug.key }"
                    >
                      {{ bug.key }}
                      <mat-icon aria-hidden="true">open_in_new</mat-icon>
                    </a>
                  } @else if (aktionAnbieten()) {
                    <button
                      mat-flat-button
                      type="button"
                      class="kpu__primaer"
                      data-testid="ki-pipeline-aktion"
                      aria-haspopup="dialog"
                      (click)="aktionAusloesen(a, kat)"
                    >
                      {{ 'ki.pipeline.erklaeren.aktionTyp.' + a.aktionTyp | translate }}
                    </button>
                  }
                  @if (erneutStartenAnbieten()) {
                    <button
                      mat-stroked-button
                      type="button"
                      class="kpu__sekundaer"
                      data-testid="ki-pipeline-erneut-starten"
                      (click)="erneutStarten.emit()"
                    >
                      {{ 'ki.pipeline.erklaeren.erneutStarten' | translate }}
                    </button>
                  }
                </div>
              </div>
            }
          </div>

          @if (a.wiederkehrend; as wieder) {
            <p class="kpu__wiederkehrend" data-testid="ki-pipeline-wiederkehrend">
              <strong>{{ 'ki.pipeline.erklaeren.wiederkehrend.label' | translate }}</strong>
              @if (wieder.commit; as commit) {
                {{ 'ki.pipeline.erklaeren.wiederkehrend.mitCommit' | translate: { anzahl: wieder.anzahl } }}
                <code class="kpu__commit">{{ commit }}</code>
                <!-- Zwischen zwei Elementen entfernt Angular den Zeilenumbruch, vor einem Textknoten nicht. -->
                <span>.</span>
              } @else {
                {{ 'ki.pipeline.erklaeren.wiederkehrend.ohneCommit' | translate: { anzahl: wieder.anzahl } }}
              }
            </p>
          }

          @if (a.ergebnis.logstellen.length > 0) {
            <div class="kpu__logstellen">
              <button
                type="button"
                class="kpu__log-toggle"
                data-testid="ki-logstellen-toggle"
                [attr.aria-expanded]="logstellenOffen()"
                (click)="logstellenOffen.set(!logstellenOffen())"
              >
                <mat-icon class="kpu__chevron" [class.kpu__chevron--offen]="logstellenOffen()" aria-hidden="true">
                  chevron_right
                </mat-icon>
                {{ 'ki.pipeline.erklaeren.logstellen' | translate: { anzahl: a.ergebnis.logstellen.length } }}
              </button>
              @if (logstellenOffen()) {
                <div class="kpu__log-liste" data-testid="ki-logstellen">
                  @for (stelle of a.ergebnis.logstellen; track $index) {
                    <div class="kpu__log-block">
                      <div class="kpu__log-kopf">
                        <code class="kpu__log-schritt">{{ jobUndSchritt(stelle.job, stelle.schritt) }}</code>
                        <span>
                          {{ 'ki.pipeline.erklaeren.logZeilen' | translate: { von: stelle.von, bis: stelle.bis } }}
                        </span>
                        <span class="kpu__spacer"></span>
                        @if (stelle.url; as url) {
                          <a class="kpu__log-link" [href]="url" target="_blank" rel="noopener noreferrer">
                            {{ 'ki.pipeline.ursache.ciOeffnen' | translate }}
                            <span aria-hidden="true">↗</span>
                          </a>
                        }
                      </div>
                      @for (zeile of stelle.zeilen; track $index) {
                        <div class="kpu__log-zeile" [class.kpu__log-zeile--neu]="zeile.neu">
                          <span class="kpu__log-nr">{{ zeile.nr }}</span>
                          <span class="kpu__log-text">{{ zeile.text }}</span>
                          @if (zeile.neu) {
                            <span class="kpu__log-neu">{{ 'ki.pipeline.erklaeren.neu' | translate }}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                  <p class="kpu__log-fussnote" data-testid="ki-logstellen-fussnote">
                    {{ 'ki.pipeline.erklaeren.fussnote' | translate }}
                    @if (a.ergebnis.aufbewahrungTage; as tage) {
                      {{ 'ki.pipeline.erklaeren.fussnoteFrist' | translate: { tage } }}
                    }
                  </p>
                </div>
              }
            </div>
          }

          <app-ki-gesendet [gesendet]="a.anfrage.gesendet" />
        }
      </div>
    }
  </section>

  @if (run.hinweis(); as verbindung) {
    <app-ki-erste-nutzung
      [verbindung]="verbindung"
      (verstanden)="run.hinweisVerstanden()"
      (abgebrochen)="run.hinweisAbgebrochen()"
    />
  }
}
